<template lang="pug">
ul(class="flex items-center gap-x-2 text-sm leading-none")
    li(class="flex gap-x-2")
        NuxtLink(
            :to="{ name: 'paylink', params: { id: $route.params.id }}"
            :class="{ 'font-bold text-current cursor-default': $route.name === 'paylink' }"
        ) Information
        span /

    li(
        v-if="$route.name ==='paylink-affirm'"
        class="flex gap-x-2"
    )
        span(:class="[ $route.name === 'paylink-affirm' ? 'font-bold' : 'text-gray' ]") Affirm

    li(v-else)
        span(:class="[ $route.name === 'paylink-payment' ? 'font-bold' : 'text-gray' ]") Payment

</template>

<script>
export default {
    name: 'Breadcrumbs',
}
</script>
